import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/orders/losses/filters/Index'

import Summary from '../../containers/orders/losses/summary/Index'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Losses = (): JSX.Element => {
  const classes = useStyles()

  return (
    <MainTemplate>
      <Filters />

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12}>
          <Summary />
        </Grid>
      </Grid>
    </MainTemplate>
  )
}

export default Losses
